export function parseNumeric(value: any) {
  if (isNumeric(value)) {
    if (typeof value === 'string') {
      return parseFloat(value);
    } else {
      return value;
    }
  } else {
    return undefined;
  }
}

export function isNumeric(value: any) {
  const notNull = value !== null;
  const notEmpty = value !== '';
  const notDate = !(value instanceof Date);
  const isValidNumber = !isNaN(value);
  return notNull && notEmpty && notDate && isValidNumber;
}

export function floatToStringCurrencyInputValue(value) {
  if (value) {
    const numberValue = value.match(/[0-9]/g);
    const last = numberValue.pop();
    const secondLast = numberValue.pop() || 0;
    const decimalPart = numberValue.join('') || 0;
    return `${decimalPart}.${secondLast}${last}`;
  } else {
    return '0';
  }
}

export function floatToFourDecimals(value) {
  if (value) {
    const numberValue = value.match(/[0-9]/g);
    const last = numberValue.pop();
    const secondLast = numberValue.pop() || 0;
    const thirdLast = numberValue.pop() || 0;
    const fourthLast = numberValue.pop() || 0;
    const decimalPart = numberValue.join('') || 0;
    return `${decimalPart}.${fourthLast}${thirdLast}${secondLast}${last}`;
  } else {
    return '0';
  }
}
